// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/clouds.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/clouds/clouds.js';

mount([g0]);
